import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Navbar, Footer } from "../../components/Layout";
import { toast, Toaster } from "sonner";
import { ArrowLeft, Plus, Edit, Trash2, ExternalLink, ListChecks, Download } from "lucide-react";

export default function FormsAdmin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/forms");
      setItems(data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!confirm("Supprimer ce formulaire et toutes ses soumissions ?")) return;
    await api.delete(`/admin/forms/${id}`);
    toast.success("Formulaire supprimé");
    load();
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <Toaster richColors position="top-right" />
      <section className="max-w-6xl mx-auto px-6 md:px-8 py-12">
        <Link to="/admin" className="text-xs font-bold uppercase tracking-widest text-slate-500 hover:text-slate-900 mb-6 inline-flex items-center gap-2"><ArrowLeft className="w-3 h-3"/> Retour</Link>
        <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
          <div>
            <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Formulaires personnalisés</h1>
            <p className="text-sm text-slate-500 mt-2">Créez des formulaires sur-mesure (devis, candidature, demande…) accessibles via <code className="px-1 py-0.5 bg-slate-100">/f/&lt;slug&gt;</code>.</p>
          </div>
          <Link to="/admin/formulaires/nouveau" data-testid="add-form-btn" className="btn-brutal btn-brutal-solar px-5 py-3 font-bold uppercase tracking-wider text-sm flex items-center gap-2">
            <Plus className="w-4 h-4"/>Nouveau formulaire
          </Link>
        </div>

        {loading ? (
          <div className="p-12 text-center text-slate-500 font-mono">Chargement…</div>
        ) : items.length === 0 ? (
          <div className="bg-white border border-slate-900/15 p-12 text-center text-slate-500">
            <ListChecks className="w-12 h-12 mx-auto mb-4 text-slate-300"/>
            <p className="font-mono">Aucun formulaire pour le moment.</p>
            <p className="text-xs mt-2">Cliquez sur « Nouveau formulaire » pour commencer.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {items.map(f => (
              <div key={f.id} className="bg-white border border-slate-900/15 p-5" data-testid={`row-form-${f.id}`}>
                <div className="flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <h3 className="font-display font-bold text-lg truncate">{f.title}</h3>
                    <p className="text-xs text-slate-500 font-mono mt-1">/f/{f.slug}</p>
                    {f.description && <p className="text-sm text-slate-600 mt-2 line-clamp-2">{f.description}</p>}
                    <div className="flex gap-3 mt-3 text-xs">
                      <span className={`px-2 py-0.5 border ${f.active ? "border-emerald-700 bg-emerald-50 text-emerald-800" : "border-slate-400 bg-slate-50 text-slate-500"}`}>
                        {f.active ? "Actif" : "Inactif"}
                      </span>
                      <span className="text-slate-500">{f.fields?.length || 0} champs</span>
                      <span className="text-slate-500">{f.submissions_count || 0} soumissions</span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-1">
                    <a href={`/f/${f.slug}`} target="_blank" rel="noreferrer" title="Voir" className="p-2 border border-slate-900 hover:bg-slate-900 hover:text-white"><ExternalLink className="w-3 h-3"/></a>
                    <Link to={`/admin/formulaires/${f.id}/edit`} title="Modifier" className="p-2 border border-slate-900 hover:bg-slate-900 hover:text-white"><Edit className="w-3 h-3"/></Link>
                    <Link to={`/admin/formulaires/${f.id}/soumissions`} title="Soumissions" className="p-2 border border-slate-900 hover:bg-slate-900 hover:text-white"><Download className="w-3 h-3"/></Link>
                    <button onClick={() => remove(f.id)} title="Supprimer" className="p-2 border border-slate-900 hover:bg-red-600 hover:text-white hover:border-red-600"><Trash2 className="w-3 h-3"/></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
